/**
 * 水平移动
 */
import fvAnimation from "./fvAnimation"
export default class fvHorMove extends fvAnimation {
    constructor(shape){
        super(shape,"fvHorMove");
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.bottomLeft = AsyncFunction("return " + this.bottomLeft);
        this.topRight = AsyncFunction("return " + this.topRight);
        this.bottomLeftMove = AsyncFunction("return " + this.bottomLeftMove);
        this.topRightMove = AsyncFunction("return " + this.topRightMove);
        this.x = shape.x;
        this.originalSizeX = shape.originalSize.x;
        for (var p in this.shape.subObjects) {
            if(this.shape.subObjects[p] && this.shape.subObjects[p].$){
                this.shape.subObjects[p].x = this.shape.subObjects[p].$.x;
            }
        };
    }

    async run(canvas,value){
        //if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        var bottomLeftValue = await this.executionScript(this.bottomLeft);
        var topRightValue = await this.executionScript(this.topRight);
        var bottomLeftMoveValue = await this.executionScript(this.bottomLeftMove);
        var topRightMoveValue = await this.executionScript(this.topRightMove);
        // 点不存在不移动
        if(size === -9999){
          return;
        }
        var viewNum = (parseFloat(topRightMoveValue) - parseFloat(bottomLeftMoveValue)) * (size - parseFloat(bottomLeftValue)) / (parseFloat(topRightValue) - parseFloat(bottomLeftValue)) + parseFloat(bottomLeftMoveValue) ;
        if(size <= bottomLeftValue || size <= topRightValue ){
            if(bottomLeftMoveValue < topRightMoveValue){
                this.shape.x = parseFloat(this.x) + viewNum;
                if(this.shape.fctype.indexOf('Obj') >= 0){
                  if(this.shape.magnification){
                      this.shape.cx = this.x + viewNum/this.shape.magnification.x;
                  }else{
                      this.shape.cx = this.x + viewNum/this.shape.getMagnification().x;
                  }
                }else{
                    //图片精灵添加
                    canvas.domStyle.left = this.x + viewNum+"px";
                }
            }else if(bottomLeftMoveValue == topRightMoveValue){
                this.shape.x;
                if(this.shape.domNode){
                    this.shape.domNode.style.left;
                }
            }else{
                this.shape.x = parseFloat(this.x) - viewNum;
                if(this.shape.fctype.indexOf('Obj') >= 0){
                  if(this.shape.magnification){
                      this.shape.cx = this.x - viewNum/this.shape.magnification.x;
                  }else{
                      this.shape.cx = this.x - viewNum/this.shape.getMagnification().x;
                  }
                }else{
                    //图片精灵添加
                    canvas.domStyle.left = this.x - viewNum+"px";
                }
            }
        }
    }
    async runEx(canvas){
        var size = await this.executionScript(this.sizeFunction);
        var bottomLeftValue = await this.executionScript(this.bottomLeft);
        var topRightValue = await this.executionScript(this.topRight);
        var bottomLeftMoveValue = await this.executionScript(this.bottomLeftMove);
        var topRightMoveValue = await this.executionScript(this.topRightMove);
        var viewNum = (parseFloat(topRightMoveValue) - parseFloat(bottomLeftMoveValue)) * (size - parseFloat(bottomLeftValue)) / (parseFloat(topRightValue) - parseFloat(bottomLeftValue)) + parseFloat(bottomLeftMoveValue) ;
        // 点不存在不移动
        if(size === -9999){
          return;
        }
        if(size <= bottomLeftValue || size <= topRightValue ){
            if(bottomLeftMoveValue < topRightMoveValue){
                this.shape.x = parseFloat(this.x) + viewNum;
                this.shape.originalSize.x = this.originalSizeX - viewNum/this.shape.getMagnification().x;
                for (var p in this.shape.subObjects) {
                    if(this.shape.subObjects[p]  && this.shape.subObjects[p].$){
                        this.shape.subObjects[p].$.x = parseFloat(this.shape.subObjects[p].x) + viewNum;
                        this.shape.subObjects[p].$.originalSize.x = this.originalSizeX + viewNum/this.shape.getMagnification().x;
                    }
                };
            }else if(bottomLeftMoveValue == topRightMoveValue){
                this.shape.x;
            }else{
                this.shape.x = parseFloat(this.x) - viewNum;
                this.shape.originalSize.x = this.originalSizeX - viewNum/this.shape.getMagnification().x;
                for (var p in this.shape.subObjects) {
                    if(this.shape.subObjects[p]  && this.shape.subObjects[p].$){
                        this.shape.subObjects[p].$.x = parseFloat(this.shape.subObjects[p].x) - viewNum;
                        this.shape.subObjects[p].$.originalSize.x = this.originalSizeX - viewNum/this.shape.getMagnification().x;
                    }
                };
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvHorMove.js